import * as tslib_1 from "tslib";
import { AfterViewInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';
import { ApiOrder } from '../../../cart/models/cart-models';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { ValidatorFactories } from '../../../core/validators';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import chaining from '../../../core/helpers/chaining';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PricePipe } from '../../../shared/pipes/price.pipe';
import { BackorderCounts } from '../../models/backorder-counts';
var dateValidator = ValidatorFactories.date('mm-DD-yyyy');
var CheckoutPageComponent = /** @class */ (function () {
    function CheckoutPageComponent(store, breakpointObserver, _location, modalService, pricePipe) {
        this.store = store;
        this.breakpointObserver = breakpointObserver;
        this._location = _location;
        this.modalService = modalService;
        this.pricePipe = pricePipe;
        this._customerReferenceMaxLength = 8;
        this.onLineChange = new EventEmitter();
        this.onLineDelete = new EventEmitter();
        this.onDetails = new EventEmitter();
        this.detailsChanged = new EventEmitter();
        this.checkoutOrder = new EventEmitter();
        this.breakpoint = '(max-width: 991.98px)';
        this.controller = new ScrollMagic.Controller();
        this.formSubmitAttempt = false;
        this.formSubmissions = 0;
        this.checkoutForm = this.createCheckoutFormGroup();
        // full width - is this still used?
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
    }
    Object.defineProperty(CheckoutPageComponent.prototype, "orderSetter", {
        set: function (value) {
            if (!value)
                return;
            this.order = value;
            // get address
            var address = this.addresses && Array.isArray(this.addresses)
                ? this.addresses.find(function (a) { return a.code === value.dlvAddress; })
                : null;
            this.setAddress('delivery', address);
        },
        enumerable: true,
        configurable: true
    });
    CheckoutPageComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.controller = new ScrollMagic.Controller();
        this.breakpointObserver
            .observe([this.breakpoint])
            .subscribe(function (state) {
            if (state.matches)
                _this.removeScene();
            else if (_this.hasLines && !_this.scene)
                _this.pinForm();
        });
    };
    CheckoutPageComponent.prototype.ngOnChanges = function (changes) {
        if (this.hasLines && !this.scene)
            this.pinForm();
        if (changes && changes.checkoutPageSettings && changes.checkoutPageSettings.currentValue) {
            this.updateCheckoutFormGroup();
        }
    };
    CheckoutPageComponent.prototype.createCheckoutFormGroup = function () {
        var form = new FormGroup({
            dlvDate: new FormControl(this.deliveryDate, [Validators.required, dateValidator]),
            customerReference: new FormControl(this.reference, Validators.maxLength(this.customerReferenceMaxLength)),
            comments: new FormControl(this.remarks),
            terms: new FormControl(false, Validators.requiredTrue)
        });
        if (this.checkoutPageSettings && this.checkoutPageSettings.showOrderType) {
            form.addControl('type', new FormControl(this.type, Validators.required));
        }
        return form;
    };
    CheckoutPageComponent.prototype.updateCheckoutFormGroup = function () {
        // terms are always true when there is no terms checkbox
        if (!this.showTermsAndConditionsCheckbox) {
            this.checkoutForm.patchValue({
                terms: true
            });
        }
        // Maybe the setting checkoutPageSettings.customerReferenceMaxLength changed. Also change the control.
        this.checkoutForm.setControl('customerReference', new FormControl(this.reference, Validators.maxLength(this.customerReferenceMaxLength)));
    };
    CheckoutPageComponent.prototype.isFieldValid = function (field) {
        return (!this.checkoutForm.get(field).valid && this.checkoutForm.get(field).touched || (this.checkoutForm.get(field).untouched && this.formSubmitAttempt));
    };
    Object.defineProperty(CheckoutPageComponent.prototype, "deliveryDate", {
        get: function () {
            return (this.order && this.order.dlvDate) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "reference", {
        get: function () {
            return (this.order && this.order.customerReference) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "remarks", {
        get: function () {
            return (this.order && this.order.comments) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "currency", {
        get: function () {
            return this.order.currency;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "lines", {
        get: function () {
            return (this.order && this.order.lines) || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "type", {
        get: function () {
            return (this.order && this.order.type);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "hasLines", {
        get: function () {
            return !!this.lines.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "showDeliveryColumn", {
        get: function () {
            return !!(this.checkoutPageSettings && this.checkoutPageSettings.showDeliveryColumn);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "showTermsAndConditionsCheckbox", {
        get: function () {
            return !!(this.checkoutPageSettings && this.checkoutPageSettings.showTermsAndConditionsCheckbox);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "customerReferenceMaxLength", {
        get: function () {
            if (this.checkoutPageSettings && this.checkoutPageSettings.customerReferenceMaxLength) {
                return this.checkoutPageSettings.customerReferenceMaxLength;
            }
            return this._customerReferenceMaxLength;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "customerReferenceMaxLengthParam", {
        get: function () {
            return { length: this.customerReferenceMaxLength };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "orderButtonDisabled", {
        get: function () {
            return this.committing || !this.minOrderValueReached;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "minOrderValueFormatted", {
        get: function () {
            if (this.minOrderValue && this.minOrderValue > 0) {
                return this.pricePipe.transform(this.minOrderValue, this.order.currency);
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "minOrderValueReached", {
        get: function () {
            if (this.minOrderValue && this.minOrderValue > 0) {
                return this.order.subTotalPrice >= this.minOrderValue;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutPageComponent.prototype, "discountType", {
        get: function () {
            if (this.customerDiscounts && this.customerDiscounts.length > 0) {
                return this.customerDiscounts[0].key;
            }
        },
        enumerable: true,
        configurable: true
    });
    CheckoutPageComponent.prototype.openDetails = function (product) {
        this.onDetails.emit(product);
    };
    CheckoutPageComponent.prototype.changeLine = function ($event) {
        this.onLineChange.emit($event);
        this.updateScene();
    };
    CheckoutPageComponent.prototype.deleteLine = function ($event) {
        this.onLineDelete.emit($event);
        this.updateScene();
    };
    CheckoutPageComponent.prototype.goBack = function () {
        this._location.back();
    };
    Object.defineProperty(CheckoutPageComponent.prototype, "deliveryAddressNumber", {
        get: function () {
            return chaining(this.order, 'dlvAddress');
        },
        enumerable: true,
        configurable: true
    });
    CheckoutPageComponent.prototype.setAddress = function (type, address) {
        if (!address)
            return;
        switch (type) {
            case 'billing':
                this.billingAddress = address;
                break;
            case 'delivery':
                this.deliveryAddress = address;
                break;
        }
    };
    CheckoutPageComponent.prototype.submit = function () {
        this.formSubmitAttempt = true;
        if (this.checkoutForm.valid && this.deliveryAddress) {
            this.checkoutOrder.emit(tslib_1.__assign({}, this.order, this.checkoutForm.value, { dlvAddress: this.deliveryAddress && this.deliveryAddress.code }));
        }
        else {
            this.formSubmissions = ++this.formSubmissions;
        }
    };
    CheckoutPageComponent.prototype.pinForm = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.scene && document.getElementById('js-sliding-form')) {
                if ((document.getElementById('js-duration-target').offsetHeight - document.getElementById('js-sliding-form').offsetHeight) > 15) {
                    _this.scene = new ScrollMagic.Scene({
                        triggerElement: '#js-sliding-form',
                        offset: -122,
                        duration: (document.getElementById('js-duration-target').offsetHeight - document.getElementById('js-sliding-form').offsetHeight) - 15,
                        loglevel: 1,
                        triggerHook: 0
                    })
                        .setPin('#js-sliding-form')
                        .addTo(_this.controller);
                }
            }
        }, 500);
    };
    CheckoutPageComponent.prototype.removeScene = function () {
        if (this.scene) {
            this.scene.destroy(true);
            this.scene = '';
        }
    };
    CheckoutPageComponent.prototype.updateScene = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.scene) {
                var duration = (document.getElementById('js-duration-target').offsetHeight - document.getElementById('js-sliding-form').offsetHeight) - 15;
                if (duration < 15)
                    _this.removeScene();
                else {
                    _this.scene.duration(duration);
                    _this.scene.update();
                }
            }
        }, 500);
    };
    CheckoutPageComponent.prototype.openModal = function (content) {
        this.modalService.open(content, { size: 'lg' });
    };
    return CheckoutPageComponent;
}());
export { CheckoutPageComponent };
